module.exports = __webpack_public_path__ + "img/philadelphia-brigade.366deadd.png";